import React, { useState, useEffect } from 'react';
import {
    TableHead,
    TableBody,
    TablePagination,
    TextField,
    Grid,
    Container,
    MenuItem
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { GetCookieInfo } from '../../../logic/CookieManager';
import {
    StyledButtonOrange,
    StyledButtonContainer,
    StyledTableCell,
    StyledTableHeadRow,
    StyledTable, StyledTableBodyRow, StyledTableCellHeader
} from "../../../styles/MyStyles";
import {UpsertLookup} from "../../../logic/LookupHelper";
import {GetEnumMenuItems, GetEnumValueName} from "../../../logic/EnumHelper";
import {GetClientViewName} from "../../../logic/ClientNameHelper";

const AssetsPage = () => {
    const [assets, setAssets] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [searchQuery, setSearchQuery] = useState('');
    const navigate = useNavigate();
    const [selectedType, setSelectedType] = useState('');

    useEffect(() => {
        const fetchAssets = async () => {
            try {
                const tokenCookie = GetCookieInfo('nplt');
                const response = await fetch(process.env.REACT_APP_ASSETS_URL, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                });
                if (response.ok) {
                    const data = await response.json();
                    const assets = data.data;
                    setAssets(assets);
                    UpsertLookup('asset', assets);
                } else {
                    console.log('Fetch assets failed.');
                }
            } catch (error) {
                // Handle network errors or other exceptions
                console.log('An error occurred:', error);
            }
        };
        fetchAssets();
    }, []);

    const handleTypeFilter = (event) => {
        setSelectedType(event.target.value);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearchQueryChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleRowTap = (assetId) => {
        editAsset(assetId);
    };

    const editAsset = (assetId) => {
        navigate(`edit/${assetId}`);
    };

    const createAsset = () => {
        navigate(`edit/`);
    };

    const getAssetsMenuItems = () => {
        let items = [<MenuItem key="" value="">All</MenuItem>];
        items.push(GetEnumMenuItems('assetType'));
        return items;
    };

    // Filter the clients based on the search query
    const filteredAssets = assets ? assets.filter(
        (asset) =>
            asset.name.toLowerCase().includes(searchQuery.toLowerCase()) &&
            (selectedType === '' || asset.type === parseInt(selectedType))
    ) : [];

    // Calculate pagination values
    const totalAssets = filteredAssets.length;
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const paginatedAssets = filteredAssets.slice(startIndex, endIndex);

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                    <TextField
                        label="Search"
                        value={searchQuery}
                        onChange={handleSearchQueryChange}
                        margin="normal"
                        size="small"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} md={3}>
                    <TextField
                        select
                        label="Type"
                        value={selectedType}
                        onChange={handleTypeFilter}
                        margin="normal"
                        size="small"
                        fullWidth
                    >
                        {getAssetsMenuItems()}
                    </TextField>
                </Grid>
                <Grid item xs={12} md={6} sx={{ textAlign: 'right' }}>
                    <StyledButtonContainer>
                        <StyledButtonOrange variant="contained" onClick={createAsset} margin="normal">
                            New
                        </StyledButtonOrange>
                    </StyledButtonContainer>
                </Grid>
                <Grid item xs={12}>
                    <StyledTable>
                        <TableHead>
                            <StyledTableHeadRow>
                                <StyledTableCellHeader columncount={4}>Id</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={4}>Name</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={4}>Type</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={4}>Network</StyledTableCellHeader>
                            </StyledTableHeadRow>
                        </TableHead>
                        <TableBody>
                            {paginatedAssets.map((asset) => (
                                <StyledTableBodyRow key={asset.id}
                                                    onClick={() => handleRowTap(asset.id)}>
                                    <StyledTableCell>{asset.id}</StyledTableCell>
                                    <StyledTableCell>{asset.name}</StyledTableCell>
                                    <StyledTableCell>{GetEnumValueName('assetType', asset.type)}</StyledTableCell>
                                    <StyledTableCell>{GetEnumValueName('chainalysisNetwork', asset.network)}</StyledTableCell>
                                </StyledTableBodyRow>
                            ))}
                        </TableBody>
                    </StyledTable>
                </Grid>
                <Grid item xs={12} sx={{ textAlign: 'left' }}>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 20, 50]}
                        component="div"
                        count={totalAssets}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Grid>
            </Grid>
        </Container>
    );
};

export default AssetsPage;
